import { defineStore } from "pinia";
import axios from "axios";

export const useClientStore = defineStore("client", {
  state: () => ({
    clientIp: null,
  }),

  getters: {
    getClientIp: (state) => state.clientIp,
  },

  actions: {
    async setClientIp() {
      try {
        const { data } = await axios.get("https://api4.ipify.org?format=json");
        if (data?.ip) {
          this.clientIp = data.ip;
          return data.ip;
        }
      } catch (error) {}
      // IPv4 failed, try IPv6
      try {
        const { data } = await axios.get("https://api6.ipify.org/?format=json");
        if (data?.ip) {
          this.clientIp = data.ip;
          return data.ip;
        }
      } catch (error) {}
      this.clientIp = "2001:0db8:85a3:0000:0000:8a2e:0370:7334";
      return "2001:0db8:85a3:0000:0000:8a2e:0370:7334";
    },
  },
});
